import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Select } from 'antd';
import { applyStyleModifiers } from 'styled-components-modifiers';

const SelectField = ({
	field,
	name = 'rating',
	autoComplete = 'true',
	form: { touched, errors },
	children,
	placeholder = 'Select from...',
	marginBottom = '1.5',
	...rest
}) => {
	return (
		<FormFieldStyled marginBottom={marginBottom}>
			<CustomSelect
				style={{ width: '100%' }}
				className={`${
					touched[field.name] && errors[field.name] ? 'errors' : ''
				}`}
				error={touched[field.name] && errors[field.name]}
				autoComplete={autoComplete}
				placeholder={placeholder}
				type="select"
				{...field}
				name={name}
				onChange={(event) => {
					field.onChange(field.name)(event);
				}}
				{...rest}
			>
				{children}
			</CustomSelect>
			{touched[field.name] && errors[field.name] && (
				<FormError>{errors[field.name]}</FormError>
			)}
		</FormFieldStyled>
	);
};

const SELECT_MODIFIERS = {
	primary: ({ theme }) => css`
		border: 1px solid ${theme.personalData.form.select.border};
		border-radius: 4px;
		font-size: 1.4rem;
		background: ${theme.personalData.form.select.backgroundColor};

		&.errors {
			border: none;
		}

		&.ant-select-open {
			box-shadow: 0 0 7px ${theme.personalData.form.select.boxShadowColor};
			border: 1px solid ${theme.personalData.form.select.borderOpen};
		}

		&.ant-select-disabled {
			opacity: 0.5;
		}

		& &::placeholder {
			color: ${theme.personalData.form.select.placeholderColor};
		}
	`
};

const CustomSelect = styled(Select)`
	& .ant-select-selection {
		${({ error }) =>
			error &&
			css`
				border: 1px solid ${({ theme }) => theme.red} !important;
			`}
	}
	& .ant-select-selection__placeholder {
		color: ${({ theme }) => theme.silver} !important;
	}

	${applyStyleModifiers(SELECT_MODIFIERS)};
`;

const FormFieldStyled = styled.div`
	margin-bottom: ${({ marginBottom }) => marginBottom}rem;
	color: ${({ theme }) => theme.authentication.input.color};
`;

const FormError = styled.span`
	display: block;
	margin-top: 1rem;
	font-size: 1.2rem;
	color: ${({ theme }) => theme.red};
	text-align: left;
	padding-left: 0.7rem;
`;

SelectField.propTypes = {
	field: PropTypes.object.isRequired,
	form: PropTypes.shape({
		touched: PropTypes.object.isRequired,
		errors: PropTypes.object.isRequired
	}),
	autoComplete: PropTypes.string,
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired,
	placeholder: PropTypes.string
};

export default SelectField;
